import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeReport: "Pending Amounts",
  fromDate: "",
  toDate: "",
  filter: "This filtered period",
  reportType: "Analytics",
};

const invoiceReportSlice = createSlice({
  name: "invoiceReport",
  initialState,
  reducers: {
    setActiveReport: (state, action) => {
      state.activeReport = action.payload;
    },
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    setReportType: (state, action) => {
      state.reportType = action.payload;
    },
  },
});

export const {
  setActiveReport,
  setFromDate,
  setToDate,
  setFilter,
  setReportType,
} = invoiceReportSlice.actions;

export default invoiceReportSlice.reducer;
